import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, ParamMap } from '@angular/router'
import { lastValueFrom } from 'rxjs'
import { Tag } from 'src/api/common/api-common.interface'
import { MerchandisesApiService } from 'src/api/merchandises-api/merchandises-api.service'
import { ActionButtonDisp, FooterButtonTextAlign } from 'src/app/module/common-parts/under-btn-disp/under-btn-disp.interface'
import { AddProductQuotationService } from '../service/add-product-quotation.service'
import { QuotationSelectedGroup } from '../service/ura-create-quotation.interface'

@Component({
  selector: 'app-ura-create-add-quotation-retail',
  templateUrl: './ura-create-add-quotation-retail.component.html',
  styleUrls: ['./ura-create-add-quotation-retail.component.scss']
})
export class UraCreateAddQuotationRetailComponent implements OnInit {
  title = '見積もり作成 (追加契約)'
  index: string
  session: QuotationSelectedGroup
  organizationCompanyCd: string
  contractOrganizationCd: string
  tags: Tag[] = []
  selectedTagCd: string
  loading = true
  actionButtons: ActionButtonDisp[] = [
    {
      label: '戻る',
      textAlign: FooterButtonTextAlign.LEFT,
      actionFunction: () => {
        const backIndex = Number(this.index) - 1
        if (this.addProductQuotationService.Session?.selectedGroups[backIndex]) {
          this.router.navigate([`/ura-add-product-merchandise/${this.organizationCompanyCd}/${this.contractOrganizationCd}/${backIndex}`])
        }
        else {
          this.router.navigate([`/ura-add-contract-service-map/${this.organizationCompanyCd}/${this.contractOrganizationCd}`])
        }
      }
    },
    {
      label: '次へ',
      actionFunction: () => {
        this.pageNext()
      }
    }
  ]
  constructor(
    private activatedRoute: ActivatedRoute,
    private merchandisesService: MerchandisesApiService,
    private router: Router,
    private addProductQuotationService: AddProductQuotationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.organizationCompanyCd = params.get('organizationCompanyCd')
      this.contractOrganizationCd = params.get('contractOrganizationCd')
      this.index = params.get('index')
      const check = this.addProductQuotationService.pageInit(this.organizationCompanyCd, this.contractOrganizationCd, this.index, true)
      if (!check) { return }

      this.session = this.addProductQuotationService.getSelectedGroupSession(this.index)
      this.selectedTagCd = this.session.retail?.tagCd
      this.getRetailTags()
    })
  }

  // 小売情報取得
  async getRetailTags(): Promise<void> {
    // const ret = await this.merchandisesService.RetailTags().toPromise()
    const ret$ = this.merchandisesService.RetailTags()
    let ret = await lastValueFrom(ret$)

    if (ret?.resultCode !== 0) { return }
    this.tags = ret.data
    if (!this.selectedTagCd) {
      this.selectedTagCd = this.tags[0].tagCd
    }
    this.loading = false
  }

  async pageNext(): Promise<void> {
    if (!this.selectedTagCd) { return }
    if (this.session.retail && this.session.retail.tagCd !== this.selectedTagCd) {
      this.addProductQuotationService.clearIndexSession(this.index)
      this.session = this.addProductQuotationService.getSelectedGroupSession(this.index)
    }
    this.session.retail = this.tags.find(x => x.tagCd === this.selectedTagCd)
    const tagData = await this.getBusinessCategoryTags()
    this.session.businessCategoryTagList = tagData
    this.session.service = { tagCd: 'frimo_service', tagText: 'Frimo' }
    this.addProductQuotationService.setSelectedGroupSession(this.session, this.index)
    if (tagData.length) {
      this.router.navigate([`/ura-add-product-business-category/${this.organizationCompanyCd}/${this.contractOrganizationCd}/${this.index}`])
    } else {
      this.router.navigate([`/ura-add-product-merchandise/${this.organizationCompanyCd}/${this.contractOrganizationCd}/${this.index}`])
    }
  }

  // 業態情報取得
  async getBusinessCategoryTags(): Promise<Tag[]> {
    const retailTagCd = this.session.retail.tagCd
    // const ret = await this.merchandisesService.SearchBusinessCategoryTags(retailTagCd).toPromise()
    const ret$ = this.merchandisesService.SearchBusinessCategoryTags(retailTagCd)
    let ret = await lastValueFrom(ret$)

    if (ret?.resultCode !== 0) { return [] }
    return ret.data
  }
}
